(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["yyFooter"] = factory();
	else
		root["yyFooter"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//res.yy.com/libs/footer_test/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(28)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Footer_vue___default.a);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__API__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_swipe__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'yyFooter',
    props: {
        biz: {
            type: String,
            required: true
        },
        showMark: {
            type: String,
            required: true
        },
        videoArea: {
            type: String,
            default: '.player'
        },
        ownername: {
            type: String,
            required: true
        },
        videourl: {
            type: String,
            required: true
        },
        toastVisible: {
            type: Boolean,
            required: true
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.getTinyBottomList();
        this.initScroll(this.showMark);
        if (this.ifShowFooter(this.showMark)) {
            this.footerVisible = true;
        } else {
            this.footerVisible = false;
        }
        if (document.querySelector(this.videoArea)) {
            document.querySelector(this.videoArea).addEventListener("DOMSubtreeModified", function () {
                console.log("DOMSubtreeModified" + _this.ifShowFooter(_this.showMark));
                setTimeout(function () {
                    if (_this.ifShowFooter(_this.showMark)) {
                        // console.log('show');
                        _this.footerVisible = true;
                    } else {
                        // console.log('hide');
                        _this.footerVisible = false;
                    }
                }, 300);
                console.log(_this.footerVisible);
            }, false);
        }
    },
    data: function data() {
        return {
            edition: Number(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('edition')) || 1,
            dataList: [],
            footerVisible: false
        };
    },

    methods: {
        getTinyBottomList: function getTinyBottomList() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__API___default.a.get('//wap.yy.com/mobileweb/bottom/getBottom', {
                appType: this.edition ? this.edition - 1 : 0, // 手y0 狼人杀1 吃瓜2
                biz: this.biz // 页面类型
            }).then(function (res) {
                res = JSON.parse(res);
                _this2.dataList = res.data.sort(function (prev, next) {
                    return next.priority - prev.priority;
                });
                console.log('getTinyBottomList', _this2.dataList.length);
            });
        },
        initScroll: function initScroll(className) {
            var _this3 = this;

            var scrollKey = true;
            window.addEventListener('scroll', function () {
                if (!scrollKey) {
                    return;
                }
                scrollKey = false;
                setTimeout(function () {
                    if (_this3.ifShowFooter(className)) {
                        _this3.footerVisible = true;
                    } else {
                        _this3.footerVisible = false;
                    }
                    scrollKey = true;
                }, 300);
            });
        },
        ifShowFooter: function ifShowFooter(className) {
            var videoMark = document.querySelector(className);
            if (videoMark) {
                if (window.innerHeight < videoMark.getBoundingClientRect().top) {
                    return false;
                } else {
                    return true;
                }
            }
            return true;
            //return true;
        },
        jumpLink: function jumpLink(type, url) {
            console.log('jumpULink', type, url, this.videourl);
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].hiidoReport(104);
            var jumplink = '';
            switch (type) {
                case 0:
                    /**跳视频播放页 */
                    //console.log('jumpLink', this.videourl);
                    if (!this.videourl) {
                        if (/sv_topic/.test(window.location.href)) {
                            /** 话题页去话题页 */
                            jumplink = this.gotoTopicArea();
                        } else {
                            /**  去小视频广场*/
                            jumplink = this.gotoTinyArea();
                        }
                    } else if (Number(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('edition')) == 2) {
                        /**调起狼人杀短视频 */
                        var schemeLink = 'makefriends://Shenqu/TV/D/' + window.resid + '/' + encodeURIComponent(this.videourl);
                        var rslink = '//xh.yy.com/linkapp/duanpai?linkId=2&resid=' + window.resid + '&url=' + encodeURIComponent(this.videourl) + '&type=shortVideo&scheme=' + encodeURIComponent(schemeLink);
                        jumplink = rslink;
                    } else if (Number(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('edition')) == 3) {
                        /** 吃瓜小视频 */
                        var _schemeLink = 'yymelon://Shenqu/TV/D/' + window.resid + '/' + encodeURIComponent(this.videourl);
                        jumplink = '//ulinkmelon.yy.com/duanpai?resid=' + window.resid + '&url=' + encodeURIComponent(this.videourl) + '&type=shortVideo&edition=3&scheme=' + encodeURIComponent(_schemeLink);
                    } else if (Number(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('edition')) == 1) {
                        /**调起手Y短视频 */
                        jumplink = '//ulink.yy.com/duanpai?resid=' + window.resid + '&url=' + encodeURIComponent(this.videourl) + '&type=shortVideo';
                    }
                    break;
                case 1:
                    /**跳个人信息页H5 */
                    jumplink = url;
                    break;
                case 2:
                    /** 调起手y*/
                    jumplink = '//ulink.yy.com/web';
                    break;
                case 3:
                    /**调起狼人杀 */
                    jumplink = '//xh.yy.com/linkapp/?linkId=2&scheme=makefriends%3A%2F%2F';
                    break;
                case 4:
                    /**西瓜小视频*/
                    jumplink = '//ulinkmelon.yy.com/?scheme=yymelon%3A%2F%2F&edition=3';
                    break;
            }
            console.log(jumplink);
            window.location.href = jumplink;
        },

        /** 进入小视频广场 */
        gotoTinyArea: function gotoTinyArea() {
            if (window.edition == 1) {
                return 'http://ulink.yy.com/urlscheme?action=yymobile%3A%2F%2FTinyVideo%2FSquare&type=scheme';
            } else if (window.edition == 2) {
                return 'http://langrensha.yy.com/m/applink.html?linkId=2&scheme=makefriends%3A%2F%2FTinyVideo%2FSquare';
            } else if (window.edition == 3) {
                return 'http://ulinkmelon.yy.com/?edition=3&scheme=yymelon%3A%2F%2FTinyVideo%2FSquare';
            }
        },
        /** 进入话题 */
        gotoTopicArea: function gotoTopicArea() {
            var schemeLink = '';
            var rslink = '';
            var id = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('id');
            var edition = Number(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getURLParam('edition')) || 1;
            if (edition === 3) {
                console.log('西瓜', id);
                schemeLink = 'yymelon://Shenqu/VG/D/' + id;
                rslink = '//ulinkmelon.yy.com?edition=3&scheme=' + encodeURIComponent(schemeLink);
            } else if (edition === 2) {
                console.log('狼人杀', id);
                schemeLink = 'makefriends://Shenqu/VG/D/' + id;
                rslink = '//langrensha.yy.com/m/applink.html?linkId=2&scheme=' + encodeURIComponent(schemeLink);
            } else {
                console.log('手Y', id);
                schemeLink = 'yymobile://Shenqu/VG/D/' + id;
                rslink = '//langrensha.yy.com/m/applink.html?linkId=2&edition=1&scheme=' + encodeURIComponent(schemeLink);
            }
            return rslink;
        }
    },
    components: {
        Swipe: __WEBPACK_IMPORTED_MODULE_2__vue_swipe__["a" /* Swipe */],
        SwipeItem: __WEBPACK_IMPORTED_MODULE_2__vue_swipe__["b" /* SwipeItem */]
    }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mt-swipe-item',

  mounted: function mounted() {
    this.$parent && this.$parent.swipeItemCreated(this);
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.swipeItemDestroyed(this);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wind_dom_src_event__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wind_dom_src_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__wind_dom_src_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mt-swipe',

  created: function created() {
    this.dragState = {};
  },
  data: function data() {
    return {
      ready: false,
      dragging: false,
      userScrolling: false,
      animating: false,
      index: 0,
      pages: [],
      timer: null,
      reInitTimer: null,
      noDrag: false
    };
  },


  props: {
    speed: {
      type: Number,
      default: 300
    },

    auto: {
      type: Number,
      default: 3000
    },

    continuous: {
      type: Boolean,
      default: true
    },

    showIndicators: {
      type: Boolean,
      default: true
    },

    noDragWhenSingle: {
      type: Boolean,
      default: true
    },

    prevent: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    swipeItemCreated: function swipeItemCreated() {
      var _this = this;

      if (!this.ready) return;

      clearTimeout(this.reInitTimer);
      this.reInitTimer = setTimeout(function () {
        _this.reInitPages();
      }, 100);
    },
    swipeItemDestroyed: function swipeItemDestroyed() {
      var _this2 = this;

      if (!this.ready) return;

      clearTimeout(this.reInitTimer);
      this.reInitTimer = setTimeout(function () {
        _this2.reInitPages();
      }, 100);
    },
    translate: function translate(element, offset, speed, callback) {
      var _this3 = this,
          _arguments = arguments;

      if (speed) {
        this.animating = true;
        element.style.webkitTransition = '-webkit-transform ' + speed + 'ms ease-in-out';
        setTimeout(function () {
          element.style.webkitTransform = 'translate3d(' + offset + 'px, 0, 0)';
        }, 50);

        var called = false;

        var transitionEndCallback = function transitionEndCallback() {
          if (called) return;
          called = true;
          _this3.animating = false;
          element.style.webkitTransition = '';
          element.style.webkitTransform = '';
          if (callback) {
            callback.apply(_this3, _arguments);
          }
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wind_dom_src_event__["once"])(element, 'webkitTransitionEnd', transitionEndCallback);
        setTimeout(transitionEndCallback, speed + 100); // webkitTransitionEnd maybe not fire on lower version android.
      } else {
        element.style.webkitTransition = '';
        element.style.webkitTransform = 'translate3d(' + offset + 'px, 0, 0)';
      }
    },
    reInitPages: function reInitPages() {
      var children = this.$children;
      this.noDrag = children.length === 1 && this.noDragWhenSingle;

      var pages = [];
      this.index = 0;

      children.forEach(function (child, index) {
        pages.push(child.$el);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__["removeClass"])(child.$el, 'is-active');

        if (index === 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__["addClass"])(child.$el, 'is-active');
        }
      });

      this.pages = pages;
    },
    doAnimate: function doAnimate(towards, options) {
      var _this4 = this;

      if (this.$children.length === 0) return;
      if (!options && this.$children.length < 2) return;

      var prevPage, nextPage, currentPage, pageWidth, offsetLeft;
      var speed = this.speed || 300;
      var index = this.index;
      var pages = this.pages;
      var pageCount = pages.length;

      if (!options) {
        pageWidth = this.$el.clientWidth;
        currentPage = pages[index];
        prevPage = pages[index - 1];
        nextPage = pages[index + 1];
        if (this.continuous && pages.length > 1) {
          if (!prevPage) {
            prevPage = pages[pages.length - 1];
          }
          if (!nextPage) {
            nextPage = pages[0];
          }
        }
        if (prevPage) {
          prevPage.style.display = 'block';
          this.translate(prevPage, -pageWidth);
        }
        if (nextPage) {
          nextPage.style.display = 'block';
          this.translate(nextPage, pageWidth);
        }
      } else {
        prevPage = options.prevPage;
        currentPage = options.currentPage;
        nextPage = options.nextPage;
        pageWidth = options.pageWidth;
        offsetLeft = options.offsetLeft;
      }

      var newIndex;

      var oldPage = this.$children[index].$el;

      if (towards === 'prev') {
        if (index > 0) {
          newIndex = index - 1;
        }
        if (this.continuous && index === 0) {
          newIndex = pageCount - 1;
        }
      } else if (towards === 'next') {
        if (index < pageCount - 1) {
          newIndex = index + 1;
        }
        if (this.continuous && index === pageCount - 1) {
          newIndex = 0;
        }
      }

      var callback = function callback() {
        if (newIndex !== undefined) {
          var newPage = _this4.$children[newIndex].$el;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__["removeClass"])(oldPage, 'is-active');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wind_dom_src_class__["addClass"])(newPage, 'is-active');

          _this4.index = newIndex;
        }

        if (prevPage) {
          prevPage.style.display = '';
        }

        if (nextPage) {
          nextPage.style.display = '';
        }
      };

      setTimeout(function () {
        if (towards === 'next') {
          _this4.translate(currentPage, -pageWidth, speed, callback);
          if (nextPage) {
            _this4.translate(nextPage, 0, speed);
          }
        } else if (towards === 'prev') {
          _this4.translate(currentPage, pageWidth, speed, callback);
          if (prevPage) {
            _this4.translate(prevPage, 0, speed);
          }
        } else {
          _this4.translate(currentPage, 0, speed, callback);
          if (typeof offsetLeft !== 'undefined') {
            if (prevPage && offsetLeft > 0) {
              _this4.translate(prevPage, pageWidth * -1, speed);
            }
            if (nextPage && offsetLeft < 0) {
              _this4.translate(nextPage, pageWidth, speed);
            }
          } else {
            if (prevPage) {
              _this4.translate(prevPage, pageWidth * -1, speed);
            }
            if (nextPage) {
              _this4.translate(nextPage, pageWidth, speed);
            }
          }
        }
      }, 10);
    },
    next: function next() {
      this.doAnimate('next');
    },
    prev: function prev() {
      this.doAnimate('prev');
    },
    doOnTouchStart: function doOnTouchStart(event) {
      if (this.noDrag) return;

      var element = this.$el;
      var dragState = this.dragState;
      var touch = event.touches[0];

      dragState.startTime = new Date();
      dragState.startLeft = touch.pageX;
      dragState.startTop = touch.pageY;
      dragState.startTopAbsolute = touch.clientY;

      dragState.pageWidth = element.offsetWidth;
      dragState.pageHeight = element.offsetHeight;

      var prevPage = this.$children[this.index - 1];
      var dragPage = this.$children[this.index];
      var nextPage = this.$children[this.index + 1];

      if (this.continuous && this.pages.length > 1) {
        if (!prevPage) {
          prevPage = this.$children[this.$children.length - 1];
        }
        if (!nextPage) {
          nextPage = this.$children[0];
        }
      }

      dragState.prevPage = prevPage ? prevPage.$el : null;
      dragState.dragPage = dragPage ? dragPage.$el : null;
      dragState.nextPage = nextPage ? nextPage.$el : null;

      if (dragState.prevPage) {
        dragState.prevPage.style.display = 'block';
      }

      if (dragState.nextPage) {
        dragState.nextPage.style.display = 'block';
      }
    },
    doOnTouchMove: function doOnTouchMove(event) {
      if (this.noDrag) return;

      var dragState = this.dragState;
      var touch = event.touches[0];

      dragState.currentLeft = touch.pageX;
      dragState.currentTop = touch.pageY;
      dragState.currentTopAbsolute = touch.clientY;

      var offsetLeft = dragState.currentLeft - dragState.startLeft;
      var offsetTop = dragState.currentTopAbsolute - dragState.startTopAbsolute;

      var distanceX = Math.abs(offsetLeft);
      var distanceY = Math.abs(offsetTop);
      if (distanceX < 5 || distanceX >= 5 && distanceY >= 1.73 * distanceX) {
        this.userScrolling = true;
        return;
      } else {
        this.userScrolling = false;
        event.preventDefault();
      }
      offsetLeft = Math.min(Math.max(-dragState.pageWidth + 1, offsetLeft), dragState.pageWidth - 1);

      var towards = offsetLeft < 0 ? 'next' : 'prev';

      if (dragState.prevPage && towards === 'prev') {
        this.translate(dragState.prevPage, offsetLeft - dragState.pageWidth);
      }
      this.translate(dragState.dragPage, offsetLeft);
      if (dragState.nextPage && towards === 'next') {
        this.translate(dragState.nextPage, offsetLeft + dragState.pageWidth);
      }
    },
    doOnTouchEnd: function doOnTouchEnd() {
      if (this.noDrag) return;

      var dragState = this.dragState;

      var dragDuration = new Date() - dragState.startTime;
      var towards = null;

      var offsetLeft = dragState.currentLeft - dragState.startLeft;
      var offsetTop = dragState.currentTop - dragState.startTop;
      var pageWidth = dragState.pageWidth;
      var index = this.index;
      var pageCount = this.pages.length;

      if (dragDuration < 300) {
        var fireTap = Math.abs(offsetLeft) < 5 && Math.abs(offsetTop) < 5;
        if (isNaN(offsetLeft) || isNaN(offsetTop)) {
          fireTap = true;
        }
        if (fireTap) {
          this.$children[this.index].$emit('tap');
        }
      }

      if (dragDuration < 300 && dragState.currentLeft === undefined) return;

      if (dragDuration < 300 || Math.abs(offsetLeft) > pageWidth / 2) {
        towards = offsetLeft < 0 ? 'next' : 'prev';
      }

      if (!this.continuous) {
        if (index === 0 && towards === 'prev' || index === pageCount - 1 && towards === 'next') {
          towards = null;
        }
      }

      if (this.$children.length < 2) {
        towards = null;
      }

      this.doAnimate(towards, {
        offsetLeft: offsetLeft,
        pageWidth: dragState.pageWidth,
        prevPage: dragState.prevPage,
        currentPage: dragState.dragPage,
        nextPage: dragState.nextPage
      });

      this.dragState = {};
    }
  },

  destroyed: function destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.reInitTimer) {
      clearTimeout(this.reInitTimer);
      this.reInitTimer = null;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.ready = true;

    if (this.auto > 0) {
      this.timer = setInterval(function () {
        if (!_this5.dragging && !_this5.animating) {
          _this5.next();
        }
      }, this.auto);
    }

    this.reInitPages();

    var element = this.$el;

    element.addEventListener('touchstart', function (event) {
      if (_this5.prevent) {
        event.preventDefault();
      }
      if (_this5.animating) return;
      _this5.dragging = true;
      _this5.userScrolling = false;
      _this5.doOnTouchStart(event);
    });

    element.addEventListener('touchmove', function (event) {
      if (!_this5.dragging) return;
      _this5.doOnTouchMove(event);
    });

    element.addEventListener('touchend', function (event) {
      if (_this5.userScrolling) {
        _this5.dragging = false;
        _this5.dragState = {};
        return;
      }
      if (!_this5.dragging) return;
      _this5.doOnTouchEnd(event);
      _this5.dragging = false;
    });
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
(function (root, factory) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory();
    } else {
        root.request = factory();
    }
})(this, function () {
    var Util = {
        objectToQuery: function objectToQuery(data) {
            var queryArr = [],
                encode = encodeURIComponent,
                value,
                key,
                i,
                len;
            for (key in data) {
                if (data.hasOwnProperty(key)) {
                    value = data[key];
                    if (Object.prototype.toString.call(value) === '[object Array]') {

                        for (i = 0, len = value.length; i < len; i++) {
                            queryArr.push(encode(key) + '=' + encode(value[i]));
                        }
                    } else {
                        queryArr.push(encode(key) + '=' + encode(value));
                    }
                }
            }
            return queryArr.join('&');
        },
        guid: function guid(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++) {
                    uuid[i] = chars[0 | Math.random() * radix];
                }
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        }
    };

    function Request() {};

    Request.prototype.createXHR = function () {
        if (typeof XMLHttpRequest !== 'undeined') {

            return new XMLHttpRequest();
        } else if (typeof ActiveXObject !== 'undeined') {

            if (typeof arguments.callee.activeXString != 'string') {

                var versions = ['MSXML2.XMLHttp', 'MSXML2.XMLHttp.2.0', 'MSXML2.XMLHttp.3.0', 'MSXML2.XMLHttp.4.0', 'MSXML2.XMLHttp.5.0', 'MSXML2.XMLHttp.6.0'];

                for (var i = 0, len = versions.length; i < len; i++) {

                    try {
                        new ActiveXObject(versions[i]);
                        arguments.callee.activeXString = versions[i];
                    } catch (ex) {}
                }
            }
            return new ActiveXObject(arguments.callee.activeXString);
        } else {

            console.error('Your bowers is not support XHR!');
        }
    };

    Request.prototype.sendRequest = function (method, url, data, success, fail, isAsync) {

        var xhr = this.createXHR();
        xhr.onreadystatechange = function () {
            switch (xhr.readyState) {
                case 1:
                    // OPENED
                    break;
                case 2:
                    // HEADERS_RECEIVED
                    break;
                case 3:
                    // LOADING
                    break;
                case 4:
                    //DONE
                    if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304) {
                        var data = xhr.responseText;
                        success(data);
                    } else {
                        fail(xhr.response);
                    }
                    break;
            }
        };

        xhr.open(method, url, true);
        xhr.overrideMimeType('application/json');
        method.toLowerCase() === 'post' && xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(data);
    };

    Request.prototype.get = function (url, data) {
        var that = this;
        data = Util.objectToQuery(data);
        url = url.indexOf('?') > 0 ? url + '&' + data : url + '?' + data;
        return new Promise(function (resolve, reject) {
            that.sendRequest('get', url, null, resolve, reject, true);
        });
    };

    Request.prototype.post = function (url, data) {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.sendRequest('post', url, data, resolve, reject, true);
        });
    };

    Request.prototype.put = function (url, data) {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.sendRequest('put', url, data, resolve, reject, true);
        });
    };

    Request.prototype.delete = function (url, data) {
        var that = this;
        return new Prommise(function (resolve, reject) {
            that.sendRequest('delete', url, data, resolve, reject, true);
        });
    };

    Request.prototype.jsonp = function (url, data) {

        var head = document.getElementsByTagName('head')[0];

        return new Promise(function (resolve, reject) {

            var callbackName = 'jsonp_' + Util.guid(8, 16);
            data.callback = callbackName;
            data = Util.objectToQuery(data);

            var scriptNode = document.createElement('script');
            scriptNode.type = 'text/javascript';

            window[callbackName] = function (res) {
                head.removeChild(scriptNode);
                delete window[callbackName];
                resolve(res);
            };

            scriptNode.onerror = function () {

                head.removeChild(scriptNode);
                delete window[callbackName];
                reject({ err: 'err' });
            };

            url = url.indexOf('?') > 0 ? url + '&' + data : url + '?' + data;
            scriptNode.src = url;
            head.appendChild(scriptNode);
        });
    };

    return new Request();
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__legoToast_min_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__legoToast_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__legoToast_min_js__);
/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    toast: new __WEBPACK_IMPORTED_MODULE_0__legoToast_min_js___default.a({
        msg: "操作成功",
        time: 1200,
        extraclass: "extraclass"
    }),
    windowToast: function windowToast(msg) {
        console.log('windowToast', 'msg');
        this.toast.changeText(msg);
        this.toast.open();
    },
    /**海度上报 */
    hiidoReport: function hiidoReport(actType, hiidonum) {
        var page_type = 'tinyvideo';
        if (/sv_topic/.test(window.location.href)) {
            page_type = 'topic';
        } else if (/shenquvideo/.test(window.location.href)) {
            page_type = 'shenqu';
        } else if (/svmob/.test(window.location.href)) {
            /** 子站的上报 */
            var hevent = new hiidoEvent('yylive', '20017091');
            hevent.setActtype('104');
            hevent.setSys('5');
            hevent.reportJudge();
            return;
        }
        var hevent = new hiidoEvent('yylive', hiidonum || '20015389');
        hevent.setRef(document.referrer);
        hevent.setFrom(this.getURLParam('fromchannel') || '');
        hevent.setActtype(actType);
        hevent.setSys('5');
        hevent.setMoreinfo({
            "topic": "1",
            "page_type": page_type
        });
        hevent.reportJudge();
    },
    getURLParam: function getURLParam(name, url) {
        var re = new RegExp("[\\?&#]" + name + "=([^&#]+)", "gi");
        var ma = (url || location.href).match(re);
        var strArr;
        if (ma && ma.length > 0) {
            strArr = ma[ma.length - 1];
            var _index = strArr.indexOf("=");
            return strArr.substring(_index + 1);
        }
        return '';
    }
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
/*!
 * @project : lego-toast
 * @version : 0.0.1
 * @author  : miss
 * @update  : 2016-11-10 10:14:35 am
 * @email   : wuweishuan@yy.com
 */

!function (t, e) {
    "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.LegoToast = e() : t.LegoToast = e();
}(this, function () {
    return function (t) {
        function e(o) {
            if (n[o]) return n[o].exports;var i = n[o] = { exports: {}, id: o, loaded: !1 };return t[o].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
    }([function (t, e, n) {
        function o(t) {
            return t && t.__esModule ? t : { "default": t };
        }
        var i = n(1),
            r = o(i),
            s = n(2),
            a = o(s);
        t.exports = function () {
            function t(e) {
                (0, r["default"])(this, t), "undefined" == typeof e ? (this.msg = "操作成功", this.time = 2e3, this.extraClass = "") : (this.msg = e.msg || "", this.time = e.time || 2e3, this.extraClass = e.extraClass || ""), this.init();
            }
            return (0, a["default"])(t, [{ key: "init", value: function value() {
                    this.legoToastInner = null, this.toastTimer = null, this.toastDiv = null, this.hasToastDiv = !1, this.isToastShow = !1;
                } }, {
                key: "createModule",
                value: function value(t) {
                    this.toastDiv = document.createElement("div"), this.toastDiv.classList.add("legoToast"), this.extraClass && this.toastDiv.classList.add(this.extraClass);
                    var e = '<div class="legoToast-inner">' + this.msg + "</div>",
                        o = n(21);
                    this.toastDiv.innerHTML = "<style>" + o + "</style>" + e, document.body.appendChild(this.toastDiv), this.hasToastDiv = !0, this.legoToastInner = document.querySelector(".legoToast-inner"), "function" == typeof t && (this.legoToastInner.classList.add("legoToast-inner", "is-toastShow"), t.call(this));
                }
            }, {
                key: "open",
                value: function value() {
                    var t = this;
                    this.isToastShow || (this.hasToastDiv ? (this.legoToastInner.innerHTML = this.msg, this.toastDiv.style.display = "block", this.legoToastInner.classList.add("is-toastShow"), this.legoToastInner.classList.remove("is-toastHide"), this.toastTimer = setTimeout(function () {
                        t.close();
                    }, this.time)) : this.createModule(function () {
                        var t = this;
                        this.toastTimer = setTimeout(function () {
                            t.close();
                        }, this.time);
                    }), this.isToastShow = !0);
                }
            }, {
                key: "close",
                value: function value() {
                    var t = this;
                    this.toastTimer && clearTimeout(this.toastTimer), this.legoToastInner.classList.remove("is-toastShow"), this.legoToastInner.classList.add("is-toastHide"), setTimeout(function () {
                        t.toastDiv.style.display = "none", t.isToastShow = !1;
                    }, 450);
                }
            }, { key: "changeText", value: function value(t) {
                    this.msg = t;
                } }, { key: "changeTime", value: function value(t) {
                    this.time = t;
                } }]), t;
        }();
    }, function (t, e) {
        "use strict";

        e.__esModule = !0, e["default"] = function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        };
    }, function (t, e, n) {
        "use strict";

        function o(t) {
            return t && t.__esModule ? t : { "default": t };
        }
        e.__esModule = !0;
        var i = n(3),
            r = o(i);
        e["default"] = function () {
            function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), (0, r["default"])(t, o.key, o);
                }
            }
            return function (e, n, o) {
                return n && t(e.prototype, n), o && t(e, o), e;
            };
        }();
    }, function (t, e, n) {
        t.exports = { "default": n(4), __esModule: !0 };
    }, function (t, e, n) {
        n(5);
        var o = n(8).Object;
        t.exports = function (t, e, n) {
            return o.defineProperty(t, e, n);
        };
    }, function (t, e, n) {
        var o = n(6);
        o(o.S + o.F * !n(16), "Object", { defineProperty: n(12).f });
    }, function (t, e, n) {
        var o = n(7),
            i = n(8),
            r = n(9),
            s = n(11),
            a = "prototype",
            u = function u(t, e, n) {
            var c,
                f,
                l,
                h = t & u.F,
                p = t & u.G,
                d = t & u.S,
                m = t & u.P,
                y = t & u.B,
                v = t & u.W,
                w = p ? i : i[e] || (i[e] = {}),
                b = w[a],
                g = p ? o : d ? o[e] : (o[e] || {})[a];
            p && (n = e);
            for (c in n) {
                f = !h && g && void 0 !== g[c], f && c in w || (l = f ? g[c] : n[c], w[c] = p && "function" != typeof g[c] ? n[c] : y && f ? r(l, o) : v && g[c] == l ? function (t) {
                    var e = function e(_e, n, o) {
                        if (this instanceof t) {
                            switch (arguments.length) {
                                case 0:
                                    return new t();
                                case 1:
                                    return new t(_e);
                                case 2:
                                    return new t(_e, n);
                            }
                            return new t(_e, n, o);
                        }
                        return t.apply(this, arguments);
                    };
                    return e[a] = t[a], e;
                }(l) : m && "function" == typeof l ? r(Function.call, l) : l, m && ((w.virtual || (w.virtual = {}))[c] = l, t & u.R && b && !b[c] && s(b, c, l)));
            }
        };
        u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
    }, function (t, e) {
        var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
    }, function (t, e) {
        var n = t.exports = { version: "2.4.0" };"number" == typeof __e && (__e = n);
    }, function (t, e, n) {
        var o = n(10);
        t.exports = function (t, e, n) {
            if (o(t), void 0 === e) return t;
            switch (n) {
                case 1:
                    return function (n) {
                        return t.call(e, n);
                    };
                case 2:
                    return function (n, o) {
                        return t.call(e, n, o);
                    };
                case 3:
                    return function (n, o, i) {
                        return t.call(e, n, o, i);
                    };
            }
            return function () {
                return t.apply(e, arguments);
            };
        };
    }, function (t, e) {
        t.exports = function (t) {
            if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
        };
    }, function (t, e, n) {
        var o = n(12),
            i = n(20);
        t.exports = n(16) ? function (t, e, n) {
            return o.f(t, e, i(1, n));
        } : function (t, e, n) {
            return t[e] = n, t;
        };
    }, function (t, e, n) {
        var o = n(13),
            i = n(15),
            r = n(19),
            s = Object.defineProperty;
        e.f = n(16) ? Object.defineProperty : function (t, e, n) {
            if (o(t), e = r(e, !0), o(n), i) try {
                return s(t, e, n);
            } catch (a) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
            return "value" in n && (t[e] = n.value), t;
        };
    }, function (t, e, n) {
        var o = n(14);
        t.exports = function (t) {
            if (!o(t)) throw TypeError(t + " is not an object!");return t;
        };
    }, function (t, e) {
        t.exports = function (t) {
            return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? null !== t : "function" == typeof t;
        };
    }, function (t, e, n) {
        t.exports = !n(16) && !n(17)(function () {
            return 7 != Object.defineProperty(n(18)("div"), "a", { get: function get() {
                    return 7;
                } }).a;
        });
    }, function (t, e, n) {
        t.exports = !n(17)(function () {
            return 7 != Object.defineProperty({}, "a", { get: function get() {
                    return 7;
                } }).a;
        });
    }, function (t, e) {
        t.exports = function (t) {
            try {
                return !!t();
            } catch (e) {
                return !0;
            }
        };
    }, function (t, e, n) {
        var o = n(14),
            i = n(7).document,
            r = o(i) && o(i.createElement);
        t.exports = function (t) {
            return r ? i.createElement(t) : {};
        };
    }, function (t, e, n) {
        var o = n(14);
        t.exports = function (t, e) {
            if (!o(t)) return t;var n, i;if (e && "function" == typeof (n = t.toString) && !o(i = n.call(t))) return i;if ("function" == typeof (n = t.valueOf) && !o(i = n.call(t))) return i;if (!e && "function" == typeof (n = t.toString) && !o(i = n.call(t))) return i;throw TypeError("Can't convert object to primitive value");
        };
    }, function (t, e) {
        t.exports = function (t, e) {
            return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
        };
    }, function (t, e, n) {
        var o = n(22);"string" == typeof o ? t.exports = o : t.exports = o.toString();
    }, function (t, e, n) {
        e = t.exports = n(23)(), e.push([t.id, ".legoToast{position:fixed;left:50%;top:50%;z-index:999;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.legoToast-inner{width:auto;background:rgba(0,0,0,.8);border-radius:20px;color:#fff;padding:0 16px;height:32px;line-height:32px;font-size:14px;opacity:0}.legoToast-inner.is-toastShow{-webkit-animation-name:toastshow;animation-name:toastshow;-webkit-animation-timing-function:cubic-bezier(0,.33,.2,1);animation-timing-function:cubic-bezier(0,.33,.2,1);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.legoToast-inner.is-toastHide,.legoToast-inner.is-toastShow{-webkit-animation-delay:0s;animation-delay:0s;-webkit-animation-duration:.4s;animation-duration:.4s}.legoToast-inner.is-toastHide{-webkit-animation-name:toasthide;animation-name:toasthide;-webkit-animation-timing-function:cubic-bezier(0,.33,.2,1);animation-timing-function:cubic-bezier(0,.33,.2,1);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes toastshow{0%{opacity:0;-webkit-transform:scale(1.185);transform:scale(1.185)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes toastshow{0%{opacity:0;-webkit-transform:scale(1.185);transform:scale(1.185)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes toasthide{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform:scale(.815);transform:scale(.815)}}@keyframes toasthide{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform:scale(.815);transform:scale(.815)}}", ""]);
    }, function (t, e) {
        t.exports = function () {
            var t = [];
            return t.toString = function () {
                for (var t = [], e = 0; e < this.length; e++) {
                    var n = this[e];
                    n[2] ? t.push("@media " + n[2] + "{" + n[1] + "}") : t.push(n[1]);
                }
                return t.join("");
            }, t.i = function (e, n) {
                "string" == typeof e && (e = [[null, e, ""]]);
                for (var o = {}, i = 0; i < this.length; i++) {
                    var r = this[i][0];"number" == typeof r && (o[r] = !0);
                }
                for (i = 0; i < e.length; i++) {
                    var s = e[i];"number" == typeof s[0] && o[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), t.push(s));
                }
            }, t;
        };
    }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)(module)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swipe_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swipe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swipe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swipe_item_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swipe_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swipe_item_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__swipe_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__swipe_item_vue___default.a; });





/***/ }),
/* 11 */
/***/ (function(module, exports) {

/* eslint-disable */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

var hasClass = function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') != -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

var addClass = function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};

var removeClass = function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
};

module.exports = {
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/* eslint-disable */
var bindEvent = function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

var unbindEvent = function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

var bindOnce = function bindOnce(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    unbindEvent(el, event, listener);
  };
  bindEvent(el, event, listener);
};

module.exports = {
  on: bindEvent,
  off: unbindEvent,
  once: bindOnce
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    install: function install(Vue) {
        Vue.component('YyFooter', __WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]);
    }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".footerdf{position:absolute;width:100%;height:100%;left:0;top:0}.footerdf-title{position:absolute;left:.37333rem;bottom:0;height:1.33333rem;line-height:1.33333rem;font-weight:500;width:74%}.footerdf-title-nick{max-width:45%}.footerdf-title-nick,.footerdf-title-txt{display:block;font-size:.37333rem;color:#1d1d1d;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left}.footerdf-title-txt{width:5.73333rem}.footerdf-download{position:absolute;width:2.13333rem;height:.8rem;right:.26667rem;bottom:.33333rem;font-size:.37333rem;color:#1d1d1d;text-align:center;line-height:.8rem;font-weight:700;background:#fd0;border-radius:.66667rem}.footer{position:fixed;bottom:0;width:100%;height:2.08rem;z-index:9999}.footer:before{position:absolute;content:\"\";width:100%;height:100%;background:url(" + __webpack_require__(16) + ") repeat-x 0 0;background-size:auto 100%;left:0;top:0}.footer .mint-swipe-indicators{left:.53333rem;bottom:.06667rem}.footer .mint-swipe-indicator.is-active{background:#fde100;width:.16rem}.footer .mint-swipe-indicator{width:.08rem;height:.08rem}.footer div.footer-content{position:absolute;bottom:0;width:100%;height:1.50667rem}.footer-title{float:left;height:1.50667rem;line-height:1.50667rem;font-weight:500;width:74%;font-size:.37333rem;font-weight:700;color:#1d1d1d;text-indent:.26667rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.footer-acceptBtn{float:right;position:relative;top:50%;right:.26667rem;transform:translateY(-50%);width:2.13333rem;height:.86667rem;background:#ff0}.footer-icon{position:absolute;left:0;width:1.89333rem;height:1.89333rem;bottom:.90667rem}.footer-icon.yy{background:url(" + __webpack_require__(19) + ") no-repeat top;background-size:100% auto}.footer-icon.lr{bottom:.93333rem;background:url(" + __webpack_require__(18) + ") no-repeat top;background-size:100% auto}.footer-icon.cg{width:2.18667rem;height:2.06667rem;bottom:1.06667rem;left:-.10667rem;background:url(" + __webpack_require__(17) + ") no-repeat center 0;background-size:2.18667rem auto}.slide-enter-active{animation:slide-in .5s}.slide-leave-active{animation:slide-out .5s}@keyframes slide-in{0%{opacity:0}to{opacity:1}}@keyframes slide-out{0%{opacity:1}to{opacity:0}}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mint-swipe,.mint-swipe-items-wrap{overflow:hidden;position:relative;height:100%}.mint-swipe-items-wrap{-webkit-transform:translateZ(0);transform:translateZ(0)}.mint-swipe-items-wrap>div{position:absolute;-webkit-transform:translateX(-100%);transform:translateX(-100%);width:100%;height:100%;display:none}.mint-swipe-items-wrap>div.is-active{display:block;-webkit-transform:none;transform:none}.mint-swipe-indicators{position:absolute;bottom:10px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.mint-swipe-indicator{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2;margin:0 3px}.mint-swipe-indicator.is-active{background:#fff}", ""]);

// exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "footer-bg.png?c43b24e818073b46e7ce8f25aedc0df5";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "footer-icon-cg.png?7fb4cc7cba73d2d1c871af3d5b741eae";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "footer-icon-lr.png?b8b50a86d60474bbbc8a52b9685bef4c";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "footer-icon-yy.png?edc7eae3d604d3ffcac629ac6fc5949f";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(25),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-swipe"
  }, [_c('div', {
    ref: "wrap",
    staticClass: "mint-swipe-items-wrap"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicators),
      expression: "showIndicators"
    }],
    staticClass: "mint-swipe-indicators"
  }, _vm._l((_vm.pages), function(page, $index) {
    return _c('div', {
      staticClass: "mint-swipe-indicator",
      class: {
        'is-active': $index === _vm.index
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerVisible),
      expression: "footerVisible"
    }],
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [(_vm.dataList.length > 0) ? _c('Swipe', {
    staticClass: "footer-content",
    attrs: {
      "auto": -1
    }
  }, _vm._l((_vm.dataList), function(item) {
    return _c('Swipe-item', {
      key: "index",
      style: ({
        background: ("url(" + (item.bgImg) + ") no-repeat"),
        backgroundSize: "cover"
      })
    }, [_c('div', {
      staticClass: "footer-title"
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "footer-acceptBtn",
      style: ({
        background: ("url(" + (item.buttonImg) + ") no-repeat"),
        backgroundSize: "100%"
      }),
      on: {
        "click": function($event) {
          _vm.jumpLink(item.jumpType, item.buttonUrl)
        }
      }
    })])
  })) : _vm._e(), _vm._v(" "), (_vm.dataList.length == 0) ? _c('div', {
    staticClass: "footerdf"
  }, [_c('div', {
    staticClass: "footerdf-title"
  }, [_c('span', {
    staticClass: "footerdf-title-nick"
  }, [_vm._v(_vm._s(_vm.edition != 2 ? ' ' : _vm.ownername))]), _vm._v(" "), _c('span', {
    staticClass: "footerdf-title-txt"
  }, [_vm._v(_vm._s(_vm.edition == 1 ? '下载YY，获取更多精彩小视频！' : _vm.edition == 2 ? '邀请你一起欢乐狼人杀' : '下载吃瓜小视频 获取更多精彩'))])]), _vm._v(" "), _c('div', {
    staticClass: "footerdf-download",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.jumpLink(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.edition != 2 ? '下载' : '杀一局'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.edition == 1 ? 'footer-icon yy' : _vm.edition == 2 ? 'footer-icon lr' : 'footer-icon cg'
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-swipe-item"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7066e0da", content, true);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(15);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3cf619c7", content, true);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// yyFooter.js